<template>
  <div>
    <div :id="sectionGroup + '-widget'" class="row">
      <div class="table-responsive">
        <table
          v-if="currentWidgetList.length > 0"
          class="
            js-table-checkable
            table table-hover table-vcenter
            js-table-checkable-enabled
          "
        >
          <thead>
            <tr>
              <th class="text-center" style="width: 70px"></th>
              <th
                v-if="
                  sectionGroup !== 'mobile' &&
                  sectionGroup !== 'internet' &&
                  sectionGroup !== 'bankaccount'
                "
                width="20%"
              >
                {{ translate[lang]["Aanbieder"] }}
              </th>
              <th class="d-sm-table-cell">{{ translate[lang]["package"] }}</th>
              <th
                class="text-right d-sm-table-cell"
                v-if="
                  sectionGroup === 'mobile' ||
                  sectionGroup === 'internet' ||
                  sectionGroup === 'bankaccount'
                "
              >
                {{ translate[lang]["permonth"] }}
              </th>
              <th width="70%" class="text-right d-sm-table-cell" v-else>
                {{ translate[lang]["peryear"] }}
              </th>
            </tr>
          </thead>
          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="key in limit"
              :key="currentWidgetList[key - 1].id"
              v-if="currentWidgetList[key - 1]"
              :style="
                currentWidgetList[key - 1].id === currentWidget.default
                  ? 'background-color:rgba(0,255,0,0.2)'
                  : ''
              "
              :class="
                currentWidgetList[key - 1].disabled &&
                currentWidgetList[key - 1].id != currentWidget.default
                  ? 'disabledSupplier'
                  : ''
              "
              @click="
                setSupplier(
                  key,
                  currentWidgetList[key - 1].id,
                  currentWidgetList[key - 1].rate_period
                )
              "
            >
              <td class="text-center">
                <div
                  id="setSupplierClick"
                  class="
                    custom-control custom-radio custom-control-primary
                    d-inline-block
                  "
                >
                  <input
                    type="hidden"
                    :name="'products[' + sectionGroup + '][supplier_id]'"
                    :value="currentWidgetList[key - 1].supplier_id"
                  />
                  <input
                    type="radio"
                    v-if="
                      sectionGroup === 'mobile' ||
                      sectionGroup === 'internet' ||
                      sectionGroup === 'bankaccount'
                    "
                    class="custom-control-input"
                    :id="'sup' + currentWidgetList[key - 1].id"
                    :name="'products[' + sectionGroup + '][proposition]'"
                    :value="currentWidgetList[key - 1].id"
                    :checked="currentWidgetList[key - 1].default ? true : false"
                  />
                  <input
                    type="radio"
                    v-else
                    class="custom-control-input"
                    :id="'sup' + currentWidgetList[key - 1].id"
                    :name="'products[' + sectionGroup + '][proposition]'"
                    :value="currentWidgetList[key - 1].id"
                    v-model="currentWidget.default"
                  />
                  <label
                    class="custom-control-label"
                    :for="'sup' + currentWidgetList[key - 1].id"
                  ></label>
                </div>
              </td>
              <td
                v-if="
                  sectionGroup !== 'mobile' &&
                  sectionGroup !== 'internet' &&
                  sectionGroup !== 'bankaccount'
                "
              >
                <img
                  v-if="currentWidgetList[key - 1].logo"
                  class="img-fluid w-50"
                  :src="getImage(currentWidgetList[key - 1].logo)"
                />
              </td>
              <td class="d-sm-table-cell">
                {{
                  parseJSONSupplierName(currentWidgetList[key - 1].name, lang)
                }}
                <a
                  style="z-index: 110"
                  class="more"
                  data-toggle="modal"
                  data-target="#computedInfo"
                  @click="openModal(currentWidgetList[key - 1], $event)"
                  v-if="enums[sectionGroup] ? enums[sectionGroup].info : false"
                >
                  <i style="color: #0665d0" class="fas fa-info-circle fa"></i>
                </a>
              </td>
              <td
                class="text-right d-sm-table-cell"
                v-if="!ratesloader"
                style="white-space: nowrap"
              >
                <span
                  v-if="
                    currentWidgetList[key - 1].oldprice &&
                    currentWidgetList[key - 1].oldprice != 0
                  "
                >
                  <s
                    > {{ formatPrice(currentWidgetList[key - 1].oldprice) }} x20</s
                  >

                </span>
                <!--

                    var proposition_id = currentWidgetList[key - 1].id;
                    proposition_id

                 -->

                <span
                    v-if="
                  sectionGroup !== 'mobile' &&
                  sectionGroup !== 'internet' &&
                  sectionGroup !== 'bankaccount'
                    "
                >
                  € {{ formatPrice(getYearPriceByPropositionId(currentWidgetList[key - 1].id)) }}
                </span>

                <span v-else>
                  € {{ formatPrice(currentWidgetList[key - 1].yearly) }}
                </span>





                <span
                  class="badge badge-info font-w300"
                  v-if="currentWidgetList[key - 1].duration"
                >
                  {{ currentWidgetList[key - 1].duration }}
                  {{ translate[lang]["month"] }}
                </span>
              </td>
              <td v-else class="text-right" style="font-size: 9px">
                <i class="fa fa-asterisk fa-spin"></i>
                <i class="fa fa-asterisk fa-spin"></i>
                <i class="fa fa-asterisk fa-spin"></i>
                <i class="fa fa-asterisk fa-spin"></i>
              </td>
            </tr>
          </transition-group>
        </table>
      </div>
      <button
        type="button"
        v-if="limit < currentWidgetList.length"
        class="btn btn-light btn-block"
        @click="loadMore()"
      >
        {{ translate[lang]["loadmore"] }}
      </button>
    </div>
    <div
      v-if="
        currentwWidgetExtras.length > 0 &&
        (sectionGroup === 'mobile' ||
          sectionGroup === 'internet' ||
          sectionGroup === 'bankaccount')
      "
    >
      <PropWidgets
        :data="currentwWidgetExtras"
        :supplier="defaultSupplier(sectionGroup).supplier_id"
        :group="sectionGroup"
        :index="this.index"
      ></PropWidgets>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PropWidgets from "../widgets/PropWidgets";
//import "./flipList.scss";

export default {
  name: "SuppliersWidget",
  props: ["index", "sectionGroup", "sectionId", "sectionType", "defaultItem"],
  components: { PropWidgets },
  data() {
    return {
      limit: 6,
      list: null,
      regexNumber: /\d+/,
      isFiltered: false,
    };
  },
  created() {
    this.setInitials();
  },
  computed: {
    ...mapState({
      ratesloader: (state) => state.forms.ratesloader,
      comsumptionGas: (state) => state.forms.consumption.gas,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
      consumptionElectricitySingle: (state) =>
        state.forms.consumption.electric.single,
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
      consumptionElectricityDoubleLow: (state) =>
        state.forms.consumption.electric.double.low,
      consumptionElectricityDoubleHigh: (state) =>
        state.forms.consumption.electric.double.high,
      filterMetrics: (state) => state.forms.filterMetrics,
      addressResidential: (state) => state.forms.addressResidential,
    }),
    currentWidget() {
      return this.form.data.fields[this.index].filter(
        (x) => x.id === this.sectionId && x.type === this.sectionType
      )[0];
    },
    netconsumption() {
      return this.consumptionTotal - this.totalSolar;
    },
    consumptionTotal() {
      if (this.smartMeter == 1) {
        return (parseInt(this.consumption.electric.double.low) + parseInt(this.consumption.electric.double.high));
      } else {
        return this.consumption.electric.single;
      }
    },
        usageHigh() {
      var netHigh = parseInt(this.consumption.electric.double.high) - this.calcSolarConsumptionHigh();
      var netLow =  parseInt(this.consumption.electric.double.low) - this.calcSolarConsumptionLow();
      var difLow = Math.abs(netLow);

      // Als het hoge energie gebruik netto onder 0 uitkomt
      if (netHigh < 0) {
        return 0;
      }

      // Als het hoge energie gebruik netto boven 0 uitkomt
      if (netHigh >= 0 && netLow >= 0) {
        return netHigh;
      }

      // Als er alleen bij laag sprake is van teruglevering
      if (netLow < 0 && netHigh >= 0) {

        // als het verschil bij laag nog van de hoge consumptie afgetrokken kan worden 
        if (netHigh > difLow) {
          return netHigh - difLow;
        } else {
          return 0;
        }
      }
      return netHigh;
    },

    usageLow() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difHigh = Math.abs(netHigh);

      // Als er sprake is van teruglevering bij laag
      if (netLow < 0) {
        return 0;
      }

      // Als er geen sprake is van teruglevering bij zowel laag als hoog
      if (netHigh >= 0 && netLow >= 0) {
        return netLow;
      }

      // Als er alleen bij hoog sprake is van teruglevering
      if (netHigh < 0 && netLow >= 0) {

        // en het verschil bij hoog nog van de lage consumptie afgetrokken kan worden 
        if (netLow > difHigh) {
          return netLow - difHigh;
        } else {
          return 0;
        }
      }
      return netLow;
    },

    returnDeliveryLow() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difLow = Math.abs(netLow);
      //var difHigh = Math.abs(netHigh);
      
      // als laag netto onder de 0 uitkomt, en dit groter is dan het verschi
      if (netLow < 0 && difLow > netHigh) {
        return difLow;
      }

      // if both low and high energy usages are either positive or negative, there is no return delivery
      // Als er bij hoog sprake is van teruglevering, maar dit nog van de lage consumptie afgetrokken kan worden 
      if (netLow >= 0 && netHigh >= 0 || netLow < 0 && netHigh > 0 || netLow < 0 && netHigh < 0) {
        return 0;
      }

      // Als er sprake is van teruglevering
      if (netLow < 0) {
        return difLow;
      }
      return 0;
    },

    returnDeliveryHigh() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difHigh = Math.abs(netHigh);
      //var difLow = Math.abs(netLow);

      // als hoog netto onder de 0 uitkomt, en het verschil afgetrokken is van laag
      if (netHigh < 0 && difHigh > netLow) {
        return difHigh - this.consumption.electric.double.low;
      }

      // if both low and high energy usages are either positive or negative, there is no return delivery
      // Als er bij hoog sprake is van teruglevering, maar dit nog van de lage consumptie afgetrokken kan worden 
      if (netHigh >= 0 && netLow >= 0 || netHigh < 0 && netLow > 0 || netHigh < 0 && netLow < 0) {
        return 0;
      }

      // Als er sprake is van teruglevering
      if (netHigh < 0) {
        return difHigh;
      }

      if (netLow + netHigh < 0) {
        return Math.abs(netHigh+netLow);
      }

      return 0;
    },

    returnDelivery() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var net = parseInt(netHigh + netLow);
      if (net < 0) {
        return Math.abs(net);
      } else {
        return 0;
      }
    },

    totalSolar() {
      if (this.solar.kwhKnown == "1") {
        return parseInt(this.solar.single);
      } else {
        return this.calcSolarConsumption();
      }
    },
    currentWidgetList() {
      if (
        this.form.data.customertype === undefined ||
        this.form.data.customertype === null
      ) {
        return [];
      }
      let supplierList = [];
      if (
        this.sectionGroup === "mobile" ||
        this.sectionGroup === "bankaccount"
      ) {
        supplierList = this.currentWidget.suppliers.filter(
          (x) => x.show === 1 && x.category_field === "package"
        );
        this.$forceUpdate();
      } else if (this.sectionGroup === "internet") {
        supplierList = this.currentWidget.suppliers.filter(
          (x) => x.show === 1 && x.category_field === "package"
        );
      } else {
        supplierList = [...this.suppliersFilteredAsEnergy];

        supplierList = this.handleRates(supplierList);
      }

      if (supplierList.length == 0) {
        return [];
      }

      supplierList.forEach((item) => {
        if (item.selected === null || item.selected === undefined) {
          item.selected = 0;
        }
        this.calcYearly(item, "package");
      });

      supplierList = this.sort(supplierList, this.currentWidget);
      // if(this.addressResidential)
      //console.log('supplierList', supplierList)
      return supplierList;
    },
    currentwWidgetExtras() {
      let list = this.currentWidget.suppliers.filter(
        (x) => x.show === 1 && x.category_field !== "package"
      );

      list = this.filterBy(list);
      let speed = this.currentWidget.speed;
      let type = "nopackage";

      list.forEach((item) => {
        item.status = 0;
        item.packagesdiff = 0;

        if (speed.length > 0) {
          let speedVars = speed.filter(
            (x) => x.supplier_id === item.supplier_id
          );
          if (speedVars.length > 0) {
            this.calcYearly(
              item,
              type,
              speedVars[0].type,
              speedVars[0].orderable
            );
            return;
          }
          this.calcYearly(item, type);
        } else {
          this.calcYearly(item, type);
        }
      });

      return list;
    },
    defaultDuration() {
      return this.form.data.fields[this.index].filter(
        (x) => x.type === "duration" && x.group === this.sectionGroup
      )[0].default;
    },
    currentOverview() {
      return this.overview.filter((x) => x.id == this.currentWidget.product)[0];
    },
    currentRates() {
      return this.currentOverview.rates;
    },
    currentOverviewDetails() {
      return this.overview.filter((x) => x.id == this.currentWidget.product)[0]
        .details;
    },
    suppliersFilteredWithKwh() {
      let tempSuppliersWithKwh = this.addKwh(this.currentWidget.suppliers);

      let temSuppliersWithKwhFilter = this.filterWithKwh(
        this.meter,
        this.selectedProducts,
        tempSuppliersWithKwh
      );

      if (temSuppliersWithKwhFilter.length < 1) {
        this.removeOverviewWithFilter();
      }
      // } else {
      //   // this.setCurrentWidgetDefault(temSuppliersWithKwhFilter[0].id);
      //   // temSuppliersWithKwhFilter[0].selected = 1;
      //   // this.setOverviewWithFilter(temSuppliersWithKwhFilter);
      // }
      return temSuppliersWithKwhFilter;
    },
    suppliersFilteredWithCustomertype() {
      if (this.currentOverviewDetails <= 0) {
        return this.suppliersFilteredWithKwh;
      } else {
        let tempSuppliersWithCustomerTypeFilter = this.filterWithCustomerType(
          this.suppliersFilteredWithKwh,
          this.form.data.customertype,
          this.postcodeQuery
        );
        return tempSuppliersWithCustomerTypeFilter;
      }
    },
    suppliersFilteredAsEnergy() {
      let filtered = [...this.suppliersFilteredWithKwh];
      filtered = [...this.suppliersFilteredWithCustomertype];

      return filtered;
    },
  },
  methods: {
    getYearPriceByPropositionId(id) { // = propositie id
      var total = 0;

      if(this.selectedProducts.includes(1)) {

        if (this.meter == 1) {
          if (parseInt(this.netconsumption) > 0) {
            var rate_single = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'rate_single')
            if (rate_single !== null && rate_single !== undefined) {
              total += rate_single.rate * this.netconsumption;
            }

          } else {
            var return_delivery = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'return_delivery');
            var return_delivery_single = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'return_delivery_single');
            if (return_delivery !== null && return_delivery !== undefined) {
              total += return_delivery.rate * (this.solar.single - this.consumptionTotal);
            } else {
              total += return_delivery_single.rate * (this.solar.single - this.consumptionTotal);
            }
          }

          var fixed_charge = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'energy_fixed_charge_of_supply')
          if (fixed_charge !== null && fixed_charge !== undefined) {
            total += fixed_charge.rate * 365;
          }


          var tax_reduction = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'annual_tax_reduction');
          if (fixed_charge !== null && fixed_charge !== undefined) {
            total += tax_reduction.rate * 365;
          }

          var grid_charge = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'energy_charge_grid_operation')
          if (grid_charge !== null && grid_charge !== undefined) {

            if(
                this.postcodeQuery &&
                this.postcodeQuery.network_operators["E"] &&
                !this.postcodeQuery.error
            ) {

              total += parseFloat(this.postcodeQuery.network_operators["E"]
                  .filter((x) => x.connection_value == "3x25")[0]
                  .yearly.replace(",", "."))



            } else {
              total += grid_charge.rate * 365;
            }



          }


        } else if (this.meter == 2) {

          if (this.usageHigh > 0) {
            var rate_highd = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'rate_double_high')
            if (rate_highd !== null && rate_highd !== undefined) {
              total += rate_highd.rate * this.usageHigh;
              ;
            }
          }

          if (this.usageLow > 0) {
            var rate_lowd = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'rate_double_low')
            if (rate_lowd !== null && rate_lowd !== undefined) {
              total += rate_lowd.rate * this.usageLow;
            }
          }

          if (this.returnDeliveryHigh > 0 && this.doublereturn) {
            var return_delivery_highd = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'return_delivery_double_low')
            if (return_delivery_highd !== null && return_delivery_highd !== undefined) {
              total += return_delivery_highd.rate * this.returnDeliveryHigh;
            }

          }

          if (this.returnDeliveryLow > 0 && this.doublereturn) {
            var return_delivery_lowd = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'return_delivery_double_low');
            if (return_delivery_lowd !== null && return_delivery_lowd !== undefined) {
              total += return_delivery_lowd.rate * this.returnDeliveryLow;
            }

          }

          if (this.returnDelivery > 0 && !this.doublereturn) {
            var return_deliveryd = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'return_delivery');
            if (return_deliveryd !== null && return_deliveryd !== undefined) {
              total += return_deliveryd.rate * this.returnDeliveryLow;
            }

          }

          // add fixed charge of supply, tax reduction and grid charge
          var fixed_charged = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'energy_fixed_charge_of_supply')
          if (fixed_charged !== null && fixed_charged !== undefined) {
            total += fixed_charged.rate * 365;
          }

          var tax_reductiond = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'annual_tax_reduction')
          if (tax_reductiond !== null && tax_reductiond !== undefined) {
            total += tax_reductiond.rate * 365;
          }

          var grid_charged = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === id && rate.field === 'energy_charge_grid_operation')
          if (grid_charged !== null && grid_charged !== undefined) {
            total += grid_charged.rate * 365;
          }

        }

      }

      var gastotal = 0;

      if(this.selectedProducts.includes(2)) {

        var usage_gas = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === id && rate.field === 'usage_gas')
        if(usage_gas !== null && usage_gas !== undefined) {
          gastotal += usage_gas.rate * this.consumption.gas;
        }

        var fixed_charge_gas = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === id && rate.field === 'gas_fixed_charge_of_supply');
        if(fixed_charge_gas !== null && fixed_charge_gas !== undefined) {
          gastotal += fixed_charge_gas.rate * 365;
        }

        var grid_charge_gas = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === id && rate.field === 'gas_charge_grid_operation')
        if(grid_charge_gas !== null && grid_charge_gas !== undefined) {

          if(
              this.postcodeQuery &&
              this.postcodeQuery.network_operators["G"] &&
              !this.postcodeQuery.error
          ) {

            let gasConsumption = parseInt(this.consumption.gas);
            let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
            let yearlyPrice = 0

            if (500 > gasConsumption) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 500 m3"
              )[0].yearly.replace(",", ".")
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 4000 m3"
              )[0].yearly.replace(",", ".")
            } else if (gasConsumption >= 4000) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 >= 4000 m3"
              )[0].yearly.replace(",", ".")
            }

            gastotal += parseFloat(yearlyPrice);

          } else {

            gastotal += grid_charge_gas.rate * 365;

          }

        }

      }



      return (total+gastotal).toFixed(2);
      // this.overview.find(x => x.group === 'electricity')
      //formatPrice(currentWidgetList[key - 1].yearly);
    },
    // clearOverview() {
    //   let index = this.overview.findIndex(
    //     (a) => (a.id = this.currentOverview.id)
    //   );
    //   if (index != -1) {
    //     this.overview.splice(index, 1);
    //   }
    // },
    // selectDefaultProp4Energie(list) {
    //   if (!this.hasDefault(list)) {
    //     this.setSupplier(0, list[0].id, list[0].rate_period);
    //   }
    // },
    // hasDefault(supplierList) {
    //   supplierList.filter((a) => !!a.default && a.default > 0).length > 0;
    // },
    handleRates(list) {
      let rates = this.overview.filter((x) => x.group === this.sectionGroup)[0]
        ? this.overview.filter((x) => x.group === this.sectionGroup)[0].rates
        : [];

      let newList = [];
      list.map((supp) => {
        rates.map((x) => {
          if (supp.id === x.proposition_id) {
            if (newList.filter((x) => x.id === supp.id).length < 1) {
              newList.push(supp);
            }
          }
        });
      });
      return newList;
    },
    filterBy(list) {
      return list.filter(
        (a) =>
          this.currentRates.filter(
            (b) =>
              b.rate_period == this.defaultDuration && b.proposition_id == a.id
          ).length > 0
      );
    },
    ...mapMutations({
      setModalContentComputed: "forms/SET_MODAL_CONTENT_COMPUTED",
    }),
    addKwh(suppliers) {
      return suppliers.map((item) => {
        if (item.filters === null || item.filters === undefined) {
          item.filters = {
            kwh: {
              min: null,
              max: null,
            },
            m3: {
              min: null,
              max: null,
            },
          };
        }
        return item;
      });
    },
    filterWithKwh(meter, selectedProducts, suppliers) {
      if (meter == "1" && selectedProducts.includes(6)) {
        return suppliers.filter(
          (x) =>
            x.show === 1 &&
            (parseInt(this.consumptionElectricitySingle) <= x.filters.kwh.max ||
              x.filters.kwh.max === null) &&
            (parseInt(this.consumptionElectricitySingle) >= x.filters.kwh.min ||
              x.filters.kwh.min === null) &&
            (parseInt(this.comsumptionGas) >= x.filters.m3.min ||
              x.filters.m3.min === null) &&
            (parseInt(this.comsumptionGas) <= x.filters.m3.max ||
              x.filters.m3.max === null)
        );
      } else if (
        meter == "1" &&
        !selectedProducts.includes(6) &&
        this.selectedProducts.includes(1)
      ) {
        return suppliers.filter(
          (x) =>
            x.show === 1 &&
            (parseInt(this.consumptionElectricitySingle) <= x.filters.kwh.max ||
              x.filters.kwh.max === null) &&
            (parseInt(this.consumptionElectricitySingle) >= x.filters.kwh.min ||
              x.filters.kwh.min === null)
        );
      } else if (
        meter == "1" &&
        !selectedProducts.includes(6) &&
        this.selectedProducts.includes(2)
      ) {
        return suppliers.filter(
          (x) =>
            x.show === 1 &&
            (parseInt(this.comsumptionGas) >= x.filters.m3.min ||
              x.filters.m3.min === null ||
              parseInt(this.comsumptionGas) <= x.filters.m3.max ||
              x.filters.m3.max === null)
        );
      }

      let totalElectricityConsumption =
        parseInt(this.consumptionElectricityDoubleLow) +
        parseInt(this.consumptionElectricityDoubleHigh);

      if (meter == "2" && selectedProducts.includes(6)) {
        return suppliers.filter(
          (x) =>
            x.show === 1 &&
            (parseInt(totalElectricityConsumption) <= x.filters.kwh.max ||
              x.filters.kwh.max === null) &&
            (parseInt(totalElectricityConsumption) >= x.filters.kwh.min ||
              x.filters.kwh.min === null) &&
            (parseInt(this.comsumptionGas) >= x.filters.m3.min ||
              x.filters.m3.min === null) &&
            (parseInt(this.comsumptionGas) <= x.filters.m3.max ||
              x.filters.m3.max === null)
        );
      } else if (
        meter == "2" &&
        !selectedProducts.includes(6) &&
        this.selectedProducts.includes(1)
      ) {
        return suppliers.filter(
          (x) =>
            x.show === 1 &&
            (parseInt(totalElectricityConsumption) <= x.filters.kwh.max ||
              x.filters.kwh.max === null) &&
            (parseInt(totalElectricityConsumption) >= x.filters.kwh.min ||
              x.filters.kwh.min === null)
        );
      } else {
        return suppliers;
      }
    },
    filterWithCustomerType(suppliers, customerType, postcodeQuery) {
      let tempSuppliers = [];

      suppliers.forEach((supplier) => {
        if (customerType == 1 && supplier.supplier_type == 1) {
          tempSuppliers.push(supplier);
        } else if (
          customerType == 2 &&
          supplier.supplier_type == 2 &&
          this.currentOverviewDetails.filter((a) => a.id == supplier.id)
            .length > 0
        ) {
          if (!postcodeQuery) {
            tempSuppliers.push(supplier);
          } else if (
            postcodeQuery &&
            // postcodeQuery.gebruiksdoelen &&
            (this.filterMetrics
              .find((a) => a.type == customerType)
              .metrics.includes(
                this.currentOverviewDetails.filter(
                  (a) => a.id == supplier.id
                )[0].restriction_bag
              ) ||
              this.currentOverviewDetails.filter((a) => a.id == supplier.id)[0]
                .restriction_bag == null)
          ) {
            tempSuppliers.push(supplier);
          }
        }
      });

      return tempSuppliers;
    },
    removeOverviewWithFilter() {
      const indexCurrentOverview = this.overview.findIndex(
        (a) => a.id == this.currentOverview.id
      );
      if (indexCurrentOverview != -1) {
        this.overview.splice(indexCurrentOverview, 1);
      }
    },
    setOverviewWithFilter(supplier) {
      this.currentOverview.supplier.title = supplier[0].title;
      this.currentOverview.supplier.name = supplier[0].name;
      this.currentOverview.supplier.id = supplier[0].supplier_id;
      this.currentOverview.supplier.proposition = supplier[0].id;
    },
    setCurrentWidgetDefault(id) {
      this.currentWidget.default = id;
    },
    setInitials() {
      let widget1 = this.currentWidget.suppliers.filter(
        (x) => x.id === this.currentWidget.default
      )[0];
      this.currentWidgetList.map((item) => {
        if (
          item.rate_period !==
          this.defaultSupplier(this.sectionGroup).rate_period
        ) {
          item.disabled = 1;
        } else {
          item.disabled = 0;
        }
      });

      // if(this.currentWidget.suppliers.filter(x => x.id === widget1.id).length <= 0){
      //         this.currentWidget.suppliers.push(widget1)
      //
      //       }

      // let tempSuppliersWithKwh = this.addKwh(this.currentWidget.suppliers);

      // let temSuppliersWithKwhFilter = this.filterWithKwh(
      //   this.meter,
      //   this.selectedProducts,
      //   tempSuppliersWithKwh
      // );
      // let widget = temSuppliersWithKwhFilter.filter(x => x.default === this.currentWidget.default)[0]

      // if (temSuppliersWithKwhFilter.length < 1) {
      //   this.removeOverviewWithFilter();
      // } else {
      //   this.setCurrentWidgetDefault(widget1.default);
      //   widget.selected = 0;
      //   widget1.selected = 1;
      //   this.currentOverview.supplier.title = widget1.title;
      //   this.currentOverview.supplier.name = widget1.name;
      //   this.currentOverview.supplier.id = widget1.supplier_id;
      //   this.currentOverview.supplier.proposition = widget1.id;
      // }

      if (
        this.currentWidgetList.filter((x) => x.id === widget1.id).length > 0
      ) {
        this.setSupplier(0, widget1.id, widget1.rate_period);
      }
    },
    calcYearly(item, type, internetType, internetSpeed) {
      let overviewRate = [];
      let result = 0;
      let subscription = 0;
      item.oldprice = 0;
      item.duration = false;
      if (
        this.sectionGroup === "mobile" ||
        this.sectionGroup === "internet" ||
        this.sectionGroup === "bankaccount"
      ) {
        overviewRate = this.getOverviewRates(item);

        if (overviewRate.length > 0) {
          if (internetType) {
            if (
              overviewRate[0].packagetype !== null &&
              overviewRate[0].packagetype !== internetType
            ) {
              item.show = 0;
            }
          }

          if (
            internetSpeed &&
            overviewRate[0].speed !== null &&
            overviewRate[0].speed > internetSpeed
          ) {
            item.show = 0;
          }

          subscription = this.currentOverview.widgets.filter(
            (x) =>
              x.type === "subscription" && x.supplier_id === item.supplier_id
          );
          if (this.checkSubscriptionValid(subscription, overviewRate)) {
            [item.duration, item.oldprice] = this.setDiscountProperty(
              overviewRate,
              "subscription"
            );
          }

          result = this.getResult(subscription, overviewRate);
        }

        this.setOnetimeTotal();

        if (type == "package") {
          let defaultSupplierValue = this.defaultSupplier(this.sectionGroup);
          if (item.default != null && type == "package") {
            defaultSupplierValue.yearly = result;
          }
          let cost = defaultSupplierValue.yearly
            ? defaultSupplierValue.yearly
            : -1;
          if (cost < 0) {
            cost = overviewRate[0] ? overviewRate[0].rate : 0;
          }
          this.overview.filter((x) => x.id === item.product_id)[0].total =
            parseFloat(cost);
          this.overview.filter((x) => x.id === item.product_id)[0].yearly =
            parseFloat(cost) * 12;
        }
      } else {
        overviewRate = this.overview
          .filter((x) => x.id === item.product_id)[0]
          .rates.filter((b) => b.proposition_id === item.id);
        overviewRate.forEach((el) => {
          if (this.sectionGroup == "electricity" && item.id) {
            result = this.calcItem(result, el, "Electricity");
          } else if (this.sectionGroup == "gas" && item.id) {
            result = this.calcItem(result, el, "Gas");
          } else if (this.sectionGroup == "electricityandgas") {
            result = this.calcItem(result, el);
          }

          // if (el.rate !== "0.0000" && el.parent != 1) {
          //   result += parseFloat(el.yearly_cost);
          // }
        });
        if (this.rates && this.rates.cashbacks) {
          result +=
            this.rates.cashbacks.filter((x) => x.proposition_id == item.id)
              .length > 0
              ? parseFloat(
                  this.rates.cashbacks.filter(
                    (x) => x.proposition_id == item.id
                  )[0].per_yer_incl_vat
                )
              : 0;
        }
      }
      item.yearly = result;
      result = 0;
    },
    calcItem(result, el, name) {
      if (name == undefined) {
        if (el.field.includes("gas")) {
          name = "Gas";
        } else if (el.field.includes("double")) {
          name = "Electricity";
        } else {
          name = "Gas";
        }
      }
      if (this.addressResidential) {
        if (
          el.rate !== "0.0000" &&
          el.parent != 1 &&
          this.checkConsumptionAndAddressResidential(el, name)
        ) {
          result += parseFloat(el.yearly_cost);
        }
      } else {
        if (
          el.rate !== "0.0000" &&
          el.parent != 1 &&
          el.field != "annual_tax_reduction" &&
          this.checkConsumptionAndAddressResidential(el, name)
        ) {
          result += parseFloat(el.yearly_cost);
        }
      }
      return result;
    },
    checkSubscriptionValid(subscription, overview) {
      return (
        subscription.length > 0 &&
        parseInt(subscription[0].status) === 1 &&
        overview[0].discount.filter((a) => a.type == "subscription").length > 0
      );
    },
    setDiscountProperty(overview, discountType) {
      let duration = overview[0].discount.filter(
        (a) => a.type == discountType
      )[0].duration;
      let oldprice = overview[0].rate;
      return [duration, oldprice];
    },
    getResult(subscription, overview) {
      return subscription.length > 0 &&
        parseInt(subscription[0].status) === 1 &&
        overview[0].discount.filter((a) => a.type == "subscription").length > 0
        ? parseFloat(overview[0].rate) +
            overview[0].discount.filter((a) => a.type == "subscription")[0].rate
        : overview[0].rate;
    },
    getOverviewRates(item) {
      return this.currentOverview.rates.filter(
        (b) =>
          b.proposition_id === item.id && b.rate_period === this.defaultDuration
      );
    },
    setOnetimeTotal() {
      this.currentOverview.onetimetotal = 0;

      let onetimecost = 0;

      if (this.currentOverview) {
        this.currentOverview.widgets
          .filter(
            (a) =>
              a.supplier_id === this.currentOverview.supplier.id &&
              a.type === "overview"
          )
          .forEach((a) => {
            onetimecost += a.rate;
          });
      }
      this.currentOverview.onetimetotal = onetimecost;
    },
    setSupplier(key, id, rate_period) {
      this.setSupplierSelected(id, this.currentWidget);
      this.setSupplierDefault(
        id,
        this.sectionGroup,
        this.currentWidgetList,
        this.currentWidget
      );
      if (rate_period && !Array.isArray(rate_period)) {
        this.setDefaultSupplierRatePeriod(
          this.index,
          rate_period,
          this.sectionGroup,
          this.form.data.fields
        );
        this.suppliersVisible(
          this.currentWidgetList,
          rate_period,
          this.sectionGroup
        );
      }
      this.setOverview();
    },
    loadMore() {
      this.scrollAnimate("#" + this.sectionGroup + "-widget");
      let show =
        this.currentWidgetList.length - this.limit > 6
          ? 6
          : this.currentWidgetList.length - this.limit;
      this.limit += show;
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
    setSupplierSelected(id, currentWidget) {
      currentWidget.suppliers.map((item) => {
        if (id === item.id) {
          item.selected = 1;
        } else {
          item.selected = 0;
        }
      });
    },
    setSupplierDefault(id, sectionGroup, currentWidgetList, currentWidget) {
      if (
        sectionGroup === "mobile" ||
        this.sectionGroup === "internet" ||
        this.sectionGroup === "bankaccount"
      ) {
        this.currentWidgetList.forEach((item) => {
          item.default = null;
          if (item.id === id) {
            currentWidget.default = id;
            currentWidgetList.filter((a) => a.id === id)[0].default = id;
          }
        });
      } else {
        currentWidget.default = id;
      }
    },
    setDefaultSupplierRatePeriod(index, rate_period, sectionGroup, formFields) {
      formFields[index].filter(
        (item) => item.type === "duration" && item.group === sectionGroup
      )[0].default = rate_period;
    },
    sort(supplierList, currentWidget) {
      this.sortedArray(supplierList, "default");
      let temp = supplierList.filter((x) => x.id === currentWidget.default);
      let temp2 = supplierList.filter(
        (x) => x.id != currentWidget.default && x.disabled === 0
      );

      this.sortedArray(temp2, "yearly");
      let temp3 = supplierList.filter(
        (x) => x.id != currentWidget.default && x.disabled === 1
      );

      this.sortedArray(temp3, "yearly");
      supplierList = [...temp, ...temp2, ...temp3];
      return supplierList;
    },
    openModal(item) {
      if (this.currentRates && this.currentRates.length > 0) {
        this.setModalContentComputed({
          title:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .title
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].title[this.lang]
                : null
              : null,
          description:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .description
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].description[this.lang]
                : null
              : null,
        });
        // e.stopPropagation();
        // window.$("#computedInfo").modal();
      }
    },
  },
  watch: {
    // currentWidgetList(val) {
    //   if (
    //     [1, 2, 6].includes(this.currentWidget.product) &&
    //     val &&
    //     val.length > 0 &&
    //     val.filter((a) => a.id == val[0].default).length < 1
    //   ) {
    //     this.setSupplier(0, val[0].id, val[0].rate_period);
    //   }
    // },
  },
};
</script>

<style lang="css">
.flip-list-move {
    transition: all 1s ease;
}
</style>
